import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Logo from './logo';
import MenuEscriptori from './menu/menuEscriptori';
import MenuMobil from './menu/menuMobil';

class Capcalera extends Component {

    render() {
        const urlActual = this.props.urlActual;
        return (
            <nav className="navbar navbar-default navbar-static-top">
                <Logo />
                <MenuEscriptori urlActual={urlActual} />
                <MenuMobil urlActual={urlActual} />
            </nav>
        );
    }
}

Capcalera.propTypes = {
    urlActual: PropTypes.string
};

export default Capcalera;



// WEBPACK FOOTER //
// ./src/components/capcalera/capcalera.js